// src/components/Portfolio.js
import React, { useState, useEffect } from 'react';
import './Portfolio.css';
import PortfolioGrid from './PortfolioGrid';
import AudioWave from './AudioWave';

import {
  FaExternalLinkAlt,
  FaSpotify, FaYoutube, FaApple, FaAmazon 
} from 'react-icons/fa';

import { SiTidal } from 'react-icons/si';

const releases = [
  {
    id: 'cherry',
    img: '/projects/cbd.webp',
    title: 'Cherry Blossom Droplets',
    description: 'Cherry Blossom Droplets, now available on all major music platforms.',
    // audioFiles: [
    //   { title: "Cherry Blossom Droplets (Pre-Release)", url: '/audio/cherry.mp3' },
    // ],
    tags: ['Available for Streaming', 'Released Sep 2026'],
    //spotifypresave : 'https://show.co/social-unlock/5RoyvSRs4D39E5PSVyqBLd/widget'
    spotifyPlayer : 'https://open.spotify.com/embed/track/6UHwPWfUQmvK1QkE827ens', 
    listenOn: [
      {spotify:'https://open.spotify.com/track/6UHwPWfUQmvK1QkE827ens'},
      {youtube:'https://music.youtube.com/watch?v=wRlPLPT4JB4'},
      {apple:'https://music.apple.com/album/cherry-blossom-droplets-single/6806358677'},
      {tidal:'https://tidal.com/track/556490461'},
      {amazon:'https://music.amazon.co.uk/albums/B0HH13X4BT'}
    ]
  },
  {
    id: 'epilogue',
    img: '/projects/epilogue.webp',
    title: 'Christmas Epilogue',
    description: 'Christmas Epilogue, now available on all major music platforms.',
    // audioFiles: [
    //   { title: "Christmas Epilogue (Pre-Release)", url: '/audio/epilogue.mp3' },
    // ],
    tags: ['Available for Streaming', 'Released Aug 2026'],
    imgborder: true,
    spotifyPlayer : 'https://open.spotify.com/embed/track/2zSnth6TA4qfMsRBji0VL4', 
    listenOn: [
      {spotify:'https://open.spotify.com/track/2zSnth6TA4qfMsRBji0VL4'},
      {youtube:'https://music.youtube.com/watch?v=ZvC1gweGFYA'},
      {apple:'https://music.apple.com/album/christmas-epilogue-single/6796766313'},
      {tidal:'https://tidal.com/track/548187093'},
      {amazon:'https://music.amazon.co.uk/albums/B0HCF81RS2'}
    ]
  },
  {
    id: 'fiverays',
    img: '/projects/rays.webp',
    title: 'Five Rays of Sunshine',
    description: 'Five Rays of Sunshine is my latest release, now available on all major music platforms.',
    // audioFiles: [
    //   { title: "Five Rays of Sunshine (Pre-Release)", url: '/audio/rays-clip.mp3', markers: [] },
    // ],
    tags: ['Available for Streaming','Released Jul 2026'],
    imgborder: true,
    spotifyPlayer : 'https://open.spotify.com/embed/track/6OLLbt4WkdDzmNjQprw1PV', 
    listenOn: [
      {spotify:'https://open.spotify.com/track/6OLLbt4WkdDzmNjQprw1PV'},
      {youtube:'https://music.youtube.com/watch?v=MPIGkmRQ2ok'},
      {apple:'https://music.apple.com/album/five-rays-of-sunshine-single/6781469120'},
      {tidal:'https://tidal.com/track/534426199'},
      {amazon:'https://music.amazon.co.uk/albums/B0H5TK5B26'}
    ]
    //spotifypresave : 'https://show.co/social-unlock/2VYoF4IXYW3hFX8YU5nFO8/widget'
  },
  {
    id: 'thinking',
    img: '/projects/thinking.webp',
    title: 'Can\'t Stop Thinking',
    description: 'Can\'t Stop Thinking is now available on all major music platforms.',
    // audioFiles: [
    //   { title: "Can\'t Stop Thinking (Sample)", url: '/audio/thinking-clip.mp3', markers: [] },
    // ],
    tags: ['Available for Streaming','Released Apr 2026'],
    imgborder: true,
    spotifyPlayer : 'https://open.spotify.com/embed/track/0nuDKfcour3GCshAchvHG9', 
    listenOn: [
      {spotify:'https://open.spotify.com/track/0nuDKfcour3GCshAchvHG9'},
      {youtube:'https://music.youtube.com/playlist?list=OLAK5uy_mDUBWWj2vyKGFDUA1OEjGpI5Ie-fUB5Cw'},
      {apple:'https://music.apple.com/gb/album/cant-stop-thinking-single/1886790189'},
      {tidal:'https://tidal.com/track/508896115/u'},
      {amazon:'https://music.amazon.co.uk/albums/B0GTCF7TPC?marketplaceId=A1F83G8C2ARO7P'}
    ]
    // spotifypresave : 'https://show.co/social-unlock/2QXyweRgBYuOzH2x7ncVXA/widget'
  },
  {
    id: 'npm ',
    img: '/projects/masquerade.webp',
    title: 'Waltz at Life\'s Masquerade',
    description: 'Waltz at Life’s Masquerade is a solo piano waltz shaped by tension and momentum, reflecting the fleeting nature of life and the emotions along the way.',
    // audioFiles: [
    //   { title: "Waltz at Life's Masquerade (Sample)", url: '/audio/waltz-clip.mp3', markers: [] },
    // ],
    tags: ['Available for Streaming','Released Feb 2026'],
    imgborder: true,
    spotifyPlayer : 'https://open.spotify.com/embed/track/1RIQKRVGjyyvKhsbvUKt8E', 
    listenOn: [
      {spotify:'https://open.spotify.com/track/1RIQKRVGjyyvKhsbvUKt8E?si=36ed964e9b7f46fb'},
      {youtube:'https://music.youtube.com/playlist?list=OLAK5uy_mlXpnpA8WZRXsaDgal_fi0p36M8wmqoR0'},
      {apple:'https://music.apple.com/gb/album/waltz-at-lifes-masquerade-single/1870329371'},
      {tidal:'https://tidal.com/album/490840476/track/490840477'},
      {amazon:'https://music.amazon.co.uk/albums/B0GHPGXY1D?marketplaceId=A1F83G8C2ARO7P'}
    ]
    //spotifypresave : 'https://show.co/social-unlock/0TWczBkK4Uurck2sEVzrth/widget'
  },
  {
    id: 'yearning',
    img: '/projects/yearning.webp',
    title: 'Yearning You Yet',
    description: 'Composed and recorded with live musicians in London, Yearning You Yet is a neoclassical string quartet that captures a sense of longing and nostalgia. Written with rich harmonic textures through the interplay between the four instruments, it marks my debut release as a composer.',
    tags: ['Available for Streaming','Released Oct 2025'],
    imgborder: true,
    spotifyPlayer : 'https://open.spotify.com/embed/track/1KzxfA8qXsDhhqaOUVQDIz', 
    listenOn: [
      {spotify:'https://open.spotify.com/track/1KzxfA8qXsDhhqaOUVQDIz'},
      {youtube:'https://music.youtube.com/playlist?list=OLAK5uy_n5iCoa3Op9-3juMxeG-DNgy4VlRITYBPU'},
      {apple:'https://music.apple.com/gb/album/yearning-you-yet-single/1842944500'},
      {tidal:'https://tidal.com/album/463740071/track/463740072'},
      {amazon:'https://music.amazon.co.uk/albums/B0FT69DHK6?marketplaceId=A1F83G8C2ARO7P'},
    ]
  },
]

const perfomances = [
  
  {
    img: '/projects/gugak.webp',
    title: 'Performance on Gugak Broadcasting System (Gugak TV)',
    description: 'Performance on the traditional Korean string instrument geomungo was broadcast on Gugak Broadcasting System: TV (국악방송TV) on 18 July 2021, showcasing my interpretation of Korean traditional music on national television.',
    link: 'https://www.youtube.com/watch?v=lHceGfwlfY8',
    embed: 'https://www.youtube.com/embed/lHceGfwlfY8',
    linktext: 'Watch on YouTube',
    hasVideo: true,
    tags: ['Performance'],
  },
  {
    img: '/projects/obang.webp',
    title: '\'5 Colours of Obang\' Live Perfomance',
    description: 'Live perfomance by Asian Arts Assembly 28th Feb 2026 at Brent Cross.',
    link: 'https://www.youtube.com/watch?v=yR23s2B8Dfk',
    embed: 'https://www.youtube.com/embed/yR23s2B8Dfk',
    linktext: 'Watch on YouTube',
    hasVideo: true,
    tags: ['Performance'],
  },
  {
    title: 'Sangria Stains – Solo Piano Performance at London College of Music',
    description: 'Solo piano piece composed by Jin Cho and performed by Emanuele Mollica at the London College of Music concert hall. Written for a recital themed Musical Exoticism, the piece captures the vibrant spirit of Spanish music and culture.',
    img: '/projects/sangria-thumbnail.webp',
    link: 'https://youtu.be/eE1SCukFFcc',
    embed: 'https://www.youtube.com/embed/eE1SCukFFcc',
    linktext: 'Watch on YouTube',
    hasVideo: true,
    tags: ['Performance'],
  }
];

// freelance items
const projects_and_demos = [
    {
    img: '/projects/vrmusic.webp',
    title: 'Background & Trailer Music for VR Game Huetopia (Meta Quest 3)',
    description: 'Composed immersive ambient soundscapes, background music and dynamic trailer music tailored for VR gaming.',
    link: 'https://www.meta.com/en-gb/experiences/huetopia/26230755453235481/',
    linktext: 'View on Meta',
    audioFiles: [
      { title: "Huetopia Trailer", url: '/audio/Huetopia Trailer.mp3' },
      { title: "Huetopia Background Music", url: '/audio/Huetopia revision 2.mp3' },
    ],
    tags: ['Upcoming'],
  },

  {
    img: '/projects/chefkiss.webp',
    title: 'A Chef\'s Kiss',
    description: 'A short film brought to life with a fully original score that I composed.',
    link: 'https://www.imdb.com/title/tt41611908/',
    linktext: 'Check out the movie on IMDb',
    tags: ['Short Film'],
  },

  {
    img: '/projects/systemshock.webp',
    title: 'System Shock 2 - Audio Redesign',
    description: 'System Shock 2 - Audio Redesign | Sound Design & Music by Jin Cho',
    link: 'https://www.youtube.com/watch?v=pxk6obsXx1M',
    embed: 'https://www.youtube.com/embed/pxk6obsXx1M',
    linktext: 'Watch on YouTube',
    hasVideo: true,
    tags: ['Audio Redesign'],
  },

  {
    img: '/projects/med.webp',
    id: 'medieval',
    title: 'Medieval Fantasy BGM for Visual Media',
    description: 'BMG/OST evoking a medieval atmosphere, ideal for fantasy films, games, or trailers with a historical or dramatic tone.',
    audioFiles: [
      { title: "Demo 1", url: '/audio/Medieval Violin Idea Demo 1.mp3' },
      { title: "Demo 2", url: '/audio/Medieval Violin Idea Demo copy (2).mp3' }
    ],
    tags: ['Available for Licensing'],
  },
  {
    img: '/projects/tension.webp',
    id: 'tension',
    title: 'Tension-Building BGM for Visual Media',
    description: 'Tension-building BGM crafted to amplify tension in high-pressure scenes',
    audioFiles: [
      { title: "Tension Build", url: '/audio/Tension Build copy.mp3' },
    ],
    tags: ['Available for Licensing'],
  },
  {
    img: '/projects/nostalgia.webp',
    title: 'Nostalgia-evoking BGM',
    description: 'Nostalgia-evoking BGM crafted to deepen emotional immersion',
    audioFiles: [
      { title: "Nostalgic Waves", url: '/audio/Nostalgic Waves.mp3' },
    ],
    tags: ['Available for Licensing'],
  },
  {
    img: '/projects/soothing.webp',
    title: 'Soothing BGM Loop for Cozy Gameplay',
    description: 'Loopable BGM crafted to evoke cosiness. Ideal for healing-themed games',
    audioFiles: [
      { title: "Cheeky Skips", url: '/audio/Cheeky Skips.mp3' },
    ],
    tags: ['In Development'],
  },
]

const Portfolio = ({ modalKey }) => {
  const [selectedItem, setSelectedItem] = useState(null);

  useEffect(() => {
    if (modalKey) {
      const item = releases.find(i => i.id === modalKey)
        || projects_and_demos.find(i => i.id === modalKey)
        || perfomances.find(i => i.id === modalKey);
      if (item) setSelectedItem(item);
    } else {
      setSelectedItem(null);
    }
  }, [modalKey]);

  const openModal = (item, e) => {
    e.preventDefault();
    setSelectedItem(item);
  };

  const closeModal = () => setSelectedItem(null);

  return (
  <> 
    <PortfolioGrid 
      title="Portfolio" 
      items={releases} 
      onCardClick={openModal} 
    /> 

    <PortfolioGrid
      title="Projects & Demos"
      items={projects_and_demos}
      onCardClick={openModal}
    />
 
    <PortfolioGrid
      title="Perfomances"
      items={perfomances}
      onCardClick={openModal}
    />


    {selectedItem && (
      <div className="modal-overlay" onClick={closeModal}>
        <div className="modal-content" onClick={e => e.stopPropagation()}>
          <button className="modal-close" onClick={closeModal}>×</button>

          {/* Video */}
          {selectedItem.hasVideo ? (
            <div className="modal-image-wrapper">
              <iframe
                title={selectedItem.title}
                className="modal-video"
                src={selectedItem.embed}
                frameBorder="0"
                gesture="media"
                allow="autoplay; encrypted-media"
                allowFullScreen
              ></iframe>
            </div>
          ) : 
            // Presave
            selectedItem.spotifypresave ? (
              <div>
                <iframe src={selectedItem.spotifypresave} title='Spotify Presave' className="modal-video" frameborder="0"></iframe>
              </div>
            ) :
          
            // Image
            (
              <img
                className={selectedItem.imgborder ? 'modal-img-div-border' : 'modal-image'}
                src={selectedItem.img}
                alt={selectedItem.title}
                style={selectedItem.imgborder && {objectFit: 'contain'}}
              />
          )}

          <h3>{selectedItem.title}</h3>

          <p>{selectedItem.description}</p>

          {selectedItem.audioFiles && selectedItem.audioFiles.length > 0 && (
            <div className="modal-audio-wrapper">
              {selectedItem.audioFiles.map((audio, index) => (
                // <div key={index} className="modal-audio-item">
                //   <h4 className="modal-audio-title">{audio.title}</h4>
                //   <audio controls controlsList='nodownload noplaybackrate'>
                //     <source src={audio.url} type="audio/mpeg" />
                //     Your browser does not support the audio element.
                //   </audio>
                // </div>
                <AudioWave key={index} url={audio.url} title={audio.title} markers={audio.markers} />
              ))}
            </div>
          )}

          {selectedItem.spotifyPlayer && (
            <div className="modal-audio-wrapper">
              <iframe
                title="Spotify Player"
                src={selectedItem.spotifyPlayer}
                width="100%"
                height="80"
                frameBorder="0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="eager"
                style={{ borderRadius: '12px' }}
              ></iframe>
            </div>
          )}



          {selectedItem.listenOn && selectedItem.listenOn.length > 0 && (
            <>
              <p className="modal-platform-header">
                Available on all major streaming platforms
              </p>
              <div className="modal-platform-icons">
                {selectedItem.listenOn.map((platform, index) => {
                  const [key, url] = Object.entries(platform)[0];
                  if (!url) return null;

                  const iconMap = {
                    spotify: <FaSpotify />,
                    youtube: <FaYoutube />,
                    apple: <FaApple />,
                    tidal: <SiTidal />,
                    amazon: <FaAmazon />
                  };

                  return (
                    <a
                      key={index}
                      href={url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="platform-icon"
                      title={`Listen on ${key.charAt(0).toUpperCase() + key.slice(1)}`}
                    >
                      {iconMap[key]}
                    </a>
                  );
                })}
              </div>
            </>
          )}


          
          {selectedItem.link && (
            <div className="modal-link">
              <a href={selectedItem.link} target="_blank" rel="noopener noreferrer">
                {selectedItem.linktext} <FaExternalLinkAlt className="modal-link-go"/>
              </a>
            </div>
          )}

          {selectedItem.availableForLicensing && (
            <p className="modal-link">Contact by email for licensing details and pricing</p>
          )}

          <div className="tags">
            {selectedItem.tags && selectedItem.tags.map((tag, index) => (
              <span key={index} className={`tag ${tag.toLowerCase().replace(/\s+/g, '-')}`}>
                {tag}
              </span>
            ))}
          </div>

        </div>
      </div>
      )}
    </>
  );
};

export default Portfolio;